import React, { Fragment } from "react";
import "./styles.scss";
import truncate from "../../utils/truncate";
import numberToComma from "../../utils/numberToComma";
import cart from "../../images/cart.png";

const StoreItem = (props) => {
  const { photo, name, desc, price, action, rating } = props;
  const addDefaultSrc = (e) => {
    e.target.src = cart;
  };
  
  return (
    <Fragment>
      <div className="store-item-container" onClick={action}>
        <div className="store-item-image-container">
          <img
            src={photo}
            className="item-image"
            alt="item"
            onError={addDefaultSrc}
          />
        </div>
        <div>
          <p className="store-item-title">{truncate(name, 25)}</p>
          <div className="d-flex justify-content-between pt-2">
            <p className="store-item-desc">{desc ? truncate(desc, 25) : ""}</p>
            <p className="store-item-price">₦ {numberToComma(price)}</p>
          </div>
          <div className="d-flex justify-content-between rating">
            <p>
             {rating}
             <i className="fa fa-star store-item-icon" aria-hidden="true"></i>
            </p>
            <p>
              <i className="fa fa-shopping-cart fa-lg" aria-hidden="true"></i>
            </p>
          </div>
        </div>
      </div>

      {/* <div className="prod-container"> 
        <div className="store-image-container">
          <img 
            src={photo}
            className="store-image"
            width="100%"
            alt="Product image"
            onError={addDefaultSrc}
          />
        </div>
        
        <div className="item-descr-container">
          <p className="item-name">{truncate(name, 25)}</p>
          <div className="d-flex justify-content-between">
            <p className="item-desc">{desc ? truncate(desc, 25) : ""}</p>
            <p className="item-price">₦ {numberToComma(price)}</p>
          </div>
          <div className="d-flex justify-content-between rating">
            <p>
              <i class="fa fa-star" aria-hidden="true"></i>{" "}
              <i class="fa fa-star" aria-hidden="true"></i>{" "}
              <i class="fa fa-star" aria-hidden="true"></i>{" "}
              <i class="fa fa-star" aria-hidden="true"></i>{" "}
              <i class="fa fa-star-o" aria-hidden="true"></i>
            </p>
            <p>
              <i class="fa fa-shopping-cart" aria-hidden="true"></i>
            </p>
          </div>
        </div>
      </div> */}
    </Fragment>
  );
};

export default StoreItem;
